"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { PortableTextBlock } from "sanity";
import Button from "src/components/button/Button";
import MainText from "src/components/richtext/MainText";
import styles from './ArticleSummary.module.css';
import classNames from 'classnames';
import { locale } from "@locale";
import getThemeStyles from "src/lib/styling/getThemeStyles";

// #region [Props]
type ArticleSummaryProps = {
  summary?: PortableTextBlock[];
  className?: string;
};
// #endregion

// #region [Component]
export default function ArticleSummary(t0) {
  const $ = _c(17);
  const {
    summary,
    className
  } = t0;
  const [showAll, setShowAll] = useState(false);
  if ((summary?.length ?? 0) === 0) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    const themeStyles = getThemeStyles(styles);
    t1 = classNames(styles.SArticleSummary, className, themeStyles);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2 className={styles.SSummaryHeading}>{locale.articleSummary.label}</h2>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== showAll) {
    t3 = classNames(styles.SMainText, {
      [styles.showAll]: showAll
    });
    $[3] = showAll;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== summary || $[6] !== t3) {
    t4 = <div className={styles.SSummaryList}><MainText mainText={summary} className={t3} /></div>;
    $[5] = summary;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== showAll || $[9] !== summary) {
    t5 = !showAll && summary.length > 1 && <Button className={styles.SSummaryButton} text={locale.articleSummary.showMore} isLarge={true} onClick={() => setShowAll(true)} dkVariant="darkOutline" />;
    $[8] = showAll;
    $[9] = summary;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className={styles.SContainer}>{t2}{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t6) {
    t7 = <div className={t1}>{t6}</div>;
    $[14] = t1;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
// #endregion